var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['block.cmpBios'] = (function () {
    'use strict';

    const initialize = (widget) => {
        modalOnHash(widget)
        modalOnClick(widget);
    }

    const modalOnHash = (widget) => {
        const hash = window.location.hash;
        if (!hash) return;
        const modalEL = widget.querySelector(hash);
        if (!modalEL) return
        const modal = new bootstrap.Modal(modalEL);
        modal.show();
    };

    const modalOnClick = (widget) => {
        const modalTriggers = widget.querySelectorAll('[data-target]');
        modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                const modalEl = widget.querySelector(`.modal${trigger.getAttribute('data-target')}`);
                if (!modalEl) return;
                const modal = new bootstrap.Modal(modalEl);
                modal.show();
            });
        });

    };

    return {
        initialize
    };

})();